export default function decimalHint(val, places) {
  if (!val || isNaN(places) || places < 0) return null;
  const dotIndex = val.indexOf('.');
  if (dotIndex === -1 || places === 0)
    return val.slice(0, dotIndex === -1 ? val.length : dotIndex);
  const truncated = val.slice(0, dotIndex + places + 1);
  const currentDecimals = truncated.length - dotIndex - 1;
  return truncated + '0'.repeat(places - currentDecimals);
}
